import React, {useEffect, useMemo, useState} from "react";
import {Col, Spin} from "antd";
import _ from "lodash";
import {EnvironmentOutlined} from "@ant-design/icons";

import {CityFilter, IntegrationTypeFilter} from "../../../_defaultComponents/FilterComponents";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import PoolsListModal from "../poolsListModal/PoolsListModal";
import {useCitiesForPools} from "../../../../hooks/useCitiesForPools";
import {cities} from "../../../../constants/constants";
import {citiesToRestrictedCities} from "../../../../utils/citiesToRestrictedCities";

const Filters = ({setCurrentPage, filters, setFilters}) => {
    const [city, setCity] = useState(filters.city);
    const [integrationType, setIntegrationType] = useState(filters.integrationType);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {loading, cities: citiesData} = useCitiesForPools();
    const restrictedCities = useMemo(() => citiesToRestrictedCities(citiesData), [citiesData]);

    useEffect(() => {
        setCurrentPage(1);
    }, [city]);

    useEffect(() => {
        const newFilters = {city, integrationType};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [city, integrationType]);

    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    gap: "8px",
                    justifyContent: "space-between",
                    width: "100%"
                }}
            >
                <div style={{display: "flex", gap: "8px", width: "100%"}}>
                    <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                        <Spin spinning={loading}>
                            <CityFilter
                                value={city}
                                onChange={setCity}
                                restrictedCities={restrictedCities}
                            />
                        </Spin>
                    </Col>
                    <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                        <IntegrationTypeFilter
                            value={integrationType}
                            onChange={setIntegrationType}
                        />
                    </Col>
                </div>
                {city !== "all" && (
                    <div style={{display: "flex", gap: "8px"}}>
                        <CustomButton type="secondary" onClick={() => setIsModalOpen(true)}>
                            <EnvironmentOutlined style={{marginRight: "1px"}} />
                            Şehir Haritası
                        </CustomButton>
                        {isModalOpen && (
                            <PoolsListModal
                                isModalOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                city={city}
                            />
                        )}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default Filters;
